import React from "react";
// import Header from 'webapp/components/Header/Header'
// import TitleBar from 'webapp/components/TitleBar/TitleBar'
//import Footer from 'webapp/components/Footer'

import { Header, PaginationHelper, TitleBar } from "webapp/components";
import "./ConfirmVehicle.scss";
import carIcon from "assets/ui-img/carWhiteCircleBg.png";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useState } from "react";
import VehicleInfo from "webapp/components/VehicleInfo/VehicleInfo";

/**
 *
 * @param {
 * currState - imports the current form information into the view if it exists
 * onUserNext - imports the callback function which will update the main state
 *  with new a new vehicle year, make, model, and color
 * backButtonFunc - imports the functionality to regress the webapp by one state
 *  to the confirm customer information in this case
 * } props
 * @returns
 */
export default function ConfirmVehicle(props) {
  const { t } = useTranslation();
  const [vehicleInfoObj, setVehicleInfoObj] = useState({
    year: props.currState.Year,
    make: props.currState.Make,
    model: props.currState.Model,
    color: props.currState.Color,
    weight: props.currState.Weight,
  });

  const [disableYear, setDisableYear] = useState(props.allowVehicleInfoEdits === false && props.currState.Year?.length);
  const [disableMake, setDisableMake] = useState(props.allowVehicleInfoEdits === false && props.currState.Make?.length);
  const [disableModel, setDisableModel] = useState(
    props.allowVehicleInfoEdits === false && props.currState.Model?.length,
  );
  const [disableColor, setDisableColor] = useState(
    props.allowVehicleInfoEdits === false && props.currState.Color?.length,
  );

  const [vehicleSearchEnabled, setVehicleSearchEnabled] = useState(true);

  useEffect(() => {
    setDisableYear(props.allowVehicleInfoEdits === false && props.currState.Year?.length);
    setDisableMake(props.allowVehicleInfoEdits === false && props.currState.Make?.length);
    setDisableModel(props.allowVehicleInfoEdits === false && props.currState.Model?.length);
    setDisableColor(props.allowVehicleInfoEdits === false && props.currState.Color?.length);
    setVehicleSearchEnabled(true);
  }, [props.allowVehicleInfoEdits]);

  const ConfirmServiceObj = {
    img: props.currState.partner === "PBFL" ? props.currState.localGroupLogo : carIcon,
    partner: props.currState.partner,
    fragment: (
      <React.Fragment>
        <p>{t("description.ConfirmVehicleTitleBar1")}</p>
      </React.Fragment>
    ),
  };

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = (data) => {
    setVehicleInfoObj(data);
    if (typeof props.onUserNext === "function") {
      props.onUserNext(data);
    }
  };

  const onUserCancel = (data) => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel(data);
    }
  };

  return (
    <div className="ConfirmVehicle">
      <Header
        currState={props.currState}
        onUserBack={onUserBack}
        information={t("description.ConfirmVehicleHeader1")}
      />
      <TitleBar data={ConfirmServiceObj} />
      <PaginationHelper context={props.context} />
      <VehicleInfo
        currState={props.currState}
        localGroup={props.localGroup}
        vehicleInfoObj={vehicleInfoObj}
        onUserNext={onUserNext}
        onUserCancel={onUserCancel}
        disableYear={disableYear}
        disableMake={disableMake}
        disableModel={disableModel}
        disableColor={disableColor}
        vehicleSearchEnabled={vehicleSearchEnabled}
        allowVehicleInfoEdits={props.allowVehicleInfoEdits}
        context={props.context}
      />
    </div>
  );
}
